export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "blank": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data"])}
      },
      "fr": {
        "blank": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["FRENCH TEXT NEEDED"])}
      }
    }
  })
}